import React from "react";
import {
    ExpenseContainer,
    ExpenseIcon,
    ExpenseContent,
    ExpenseHeader,
    ExpenseCategory,
    ExpenseAmount,
} from "./styles";
import IExpense from "../../interfaces/IExpense";
import { Strong, Small } from "../../settings/layout";

import { DateTime } from "luxon";

import Icons from "../Icons";
import history from "../../services/history";

interface IProps extends IExpense {}

const Expense = (props: IProps) => {
    const { amount, category, created, icon, uuid } = props;

    return (
        <ExpenseContainer
            onClick={() => history.push({ pathname: `/app/gasto/${uuid}` })}
        >
            <ExpenseIcon>
                <Icons name={icon} width={16} height={16} />
            </ExpenseIcon>

            <ExpenseContent>
                <ExpenseHeader>
                    <ExpenseCategory>{category}</ExpenseCategory>
                    <ExpenseAmount>
                        <Small>- R$</Small> <Strong>{amount}</Strong>
                    </ExpenseAmount>
                </ExpenseHeader>
                <Small>
                    {DateTime.fromISO(created as string).toFormat("HH'h'mm")}
                </Small>
            </ExpenseContent>
        </ExpenseContainer>
    );
};

export default Expense;
